export enum ErrorDetailsProperties {
  ExceptionOriginationDate = 'Error Date Time',
  ModuleName = 'Module',
  MethodName = 'Method',
  MachineName = 'Machine',
  ErrorMessage = 'Message',  
  LoggedUserId = 'User',
  ErrorId = 'Error Id',  
  ErrorSeverity = 'Error Severity',
  StackTrace = 'Error Stack Trace',
  SignalRClientId = 'SignalR Client Id',
  HttpHeader = 'Http Headers'
}
